






















import { Component, Vue } from "vue-property-decorator";
import IconPillButton from "@/shared/components/iconPillButton/iconPillButton.vue";
import IconUser from "@/shared/components/icons/IconUser.vue";
import { CustomerHelper } from "@/shared/crm/helpers/customerHelper";
import MenuShopCart from "@/shared/components/menuShopCart/menuShopCart.vue";
import AccountMenu from "@/shared/components/accountMenu/accountMenu.vue";
import store from "@/shared/core/store";

@Component({
  components: { IconPillButton, IconUser, MenuShopCart, AccountMenu },
})
export default class EmbeddedActions extends Vue {
  userMenuOpen: boolean = false;

  get isLoggedIn() {
    return store.state.loggedIn === true;
  }

  get initial() {
    return (CustomerHelper.getStoredFirstName() || "·").charAt(0).toUpperCase();
  }

  toggleUserMenu() {
    this.userMenuOpen = !this.userMenuOpen;
  }

  closeUserMenu() {
    this.userMenuOpen = false;
  }
}
